import { z } from 'zod';
import { CoreNotifySubscriptionGroupVisibilitySchema } from '../inputTypeSchemas/CoreNotifySubscriptionGroupVisibilitySchema'

/////////////////////////////////////////
// CORE NOTIFY SUBSCRIPTION GROUP SCHEMA
/////////////////////////////////////////

export const CoreNotifySubscriptionGroupSchema = z.object({
  visibility: CoreNotifySubscriptionGroupVisibilitySchema,
  id: z.number().int(),
  cityId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  deactivatedAt: z.coerce.date().nullable(),
  name: z.string(),
  autoSubscribe: z.boolean(),
  description: z.string().nullable(),
})

export type CoreNotifySubscriptionGroup = z.infer<typeof CoreNotifySubscriptionGroupSchema>

export default CoreNotifySubscriptionGroupSchema;
